"use client"
import { useState, useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import api from "../../services/api"

export default function RegisterForm() {
  const navigate = useNavigate()
  const [fullName, setFullName] = useState("")
  const [userName, setUserName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [ plan ] = useState("free")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [searchParams] = useSearchParams();
  const [referralCode, setReferralCode] = useState("");

// On mount, check URL
useEffect(() => {
  const ref = searchParams.get("ref");
  if (ref) {
    setReferralCode(ref);
  }
}, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault()
      if (password.length < 8) {
    alert("Password must be at least 8 characters long");
    return;
  }
    setLoading(true)
    setError("")

    try {
      const res = await api.post("/auth/register", {
        fullName,
        userName,
        email,
        password,
        plan,
        referralCode,
      })

      if (!res.data?.success) {
        setError(res.data?.message || "Registration failed")
      } else {
        navigate("/verify-email", { state: { email } })
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Registration failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <style>{`
        .register-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #FFFFFF 0%, #F3F4F6 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
        }

        .register-container::before,
        .register-container::after {
          content: '';
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.08;
          animation: float 8s ease-in-out infinite;
        }

        .register-container::before {
          width: 500px;
          height: 500px;
          background: #4F46E5;
          top: -10%;
          right: -10%;
          animation-delay: 0s;
        }

        .register-container::after {
          width: 400px;
          height: 400px;
          background: #22C55E;
          bottom: -10%;
          left: -10%;
          animation-delay: 2s;
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(30px, 30px) scale(1.1); }
        }

        .register-card {
          background: #FFFFFF;
          border: 1px solid #E5E7EB;
          border-radius: 24px;
          padding: 3rem 2.5rem;
          max-width: 500px;
          width: 100%;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          position: relative;
          z-index: 1;
        }

        .register-title {
          font-size: 2rem;
          font-weight: 700;
          color: #1F2937;
          text-align: center;
          margin-bottom: 0.5rem;
          background: linear-gradient(135deg, #1130df 0%, #171b23 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .register-subtitle {
          text-align: center;
          color: #6B7280;
          font-size: 0.95rem;
          margin-bottom: 2rem;
        }

        .input-group-wrapper {
          position: relative;
          margin-bottom: 1.25rem;
        }

        .input-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #9CA3AF;
          z-index: 10;
          font-size: 1.1rem;
          transition: color 0.3s;
        }

        .register-input {
          width: 100%;
          padding: 0.875rem 1rem 0.875rem 3rem;
          background: #F9FAFB;
          border: 1px solid #E5E7EB;
          border-radius: 12px;
          color: #1F2937;
          font-size: 0.95rem;
          transition: all 0.3s;
          outline: none;
        }

        .register-input:focus {
          background: #FFFFFF;
          border-color: #0d25d8;
          box-shadow: 0 0 0 3px rgba(70, 94, 229, 0.1);
        }

        .register-input:focus + .input-icon {
          color: #0d25d8;
        }

        .register-input::placeholder {
          color: #9CA3AF;
        }

        .password-wrapper {
          position: relative;
        }

        .password-toggle {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #9CA3AF;
          cursor: pointer;
          padding: 0.25rem;
          z-index: 10;
          transition: color 0.3s;
        }

        .password-toggle:hover {
          color: #0900b9da;
        }

        .plan-selector {
          margin-bottom: 1.5rem;
        }

        .plan-label {
          display: block;
          color: #1F2937;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .plan-options {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }

        .plan-option {
          position: relative;
          cursor: pointer;
        }

        .plan-option input {
          position: absolute;
          opacity: 0;
        }

        .plan-card {
          padding: 1rem;
          background: #F9FAFB;
          border: 2px solid #E5E7EB;
          border-radius: 12px;
          text-align: center;
          transition: all 0.3s;
          cursor: pointer;
        }

        .plan-option input:checked + .plan-card {
          background: rgba(79, 70, 229, 0.05);
          border-color: #4F46E5;
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
        }

        .plan-name {
          font-weight: 600;
          color: #1F2937;
          font-size: 1rem;
          margin-bottom: 0.25rem;
        }

        .plan-price {
          font-size: 0.85rem;
          color: #6B7280;
        }

        .register-btn {
          width: 100%;
          padding: 0.875rem;
          background: linear-gradient(135deg, #1130df 0%, #171b23 100%);
          border: none;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          margin-top: 1.5rem;
        }

        .register-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(11, 58, 187, 0.55);
        }

        .register-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .btn-spinner {
          width: 18px;
          height: 18px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .error-alert {
          padding: 0.875rem 1rem;
          background: rgba(239, 68, 68, 0.1);
          border: 1px solid rgba(239, 68, 68, 0.3);
          border-radius: 12px;
          color: #DC2626;
          font-size: 0.9rem;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .register-footer {
          text-align: center;
          margin-top: 1.5rem;
          color: #6B7280;
          font-size: 0.9rem;
        }

        .register-footer a {
          color: #1d32d3d9;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.3s;
        }

        .register-footer a:hover {
          color: rgb(15, 35, 122)d9;
        }

        @media (max-width: 576px) {
          .register-card {
            padding: 2rem 1.5rem;
          }
          .register-title {
            font-size: 1.75rem;
          }
        }
      `}</style>

      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Create Account</h2>
          <p className="register-subtitle">Join us and start shortening your links</p>

          {error && (
            <div className="error-alert">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="input-group-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
              </svg>
              <input
                type="text"
                className="register-input"
                placeholder="Full Name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </div>

            <div className="input-group-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z" />
              </svg>
              <input
                type="text"
                className="register-input"
                placeholder="Username"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </div>

            <div className="input-group-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <input
                type="email"
                className="register-input"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-group-wrapper password-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                  clipRule="evenodd"
                />
              </svg>
                <input
                  type={showPassword ? "text" : "password"}
                  className="register-input"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={8}         // ← enforce 8+ characters
                  style={{ paddingRight: "3rem" }}
                />
              <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
                      clipRule="evenodd"
                    />
                    <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                    <path
                      fillRule="evenodd"
                      d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </button>
            </div>
            {searchParams.get("ref") && (
  <div style={{ fontSize: "0.85rem", color: "#4F46E5", marginBottom: "0.5rem" }}>
    Referral code applied: {referralCode}
  </div>
)}
            <div className="input-group-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 2a6 6 0 100 12 6 6 0 000-12zM2 18a8 8 0 0116 0H2z" />
              </svg>
              <input
                type="text"
                className="register-input"
                placeholder="Referral Code (optional)"
                value={referralCode}
                onChange={(e) => setReferralCode(e.target.value)}
              />
            </div>

            {/* <div className="plan-selector">
              <label className="plan-label">Choose Your Plan</label>
              <div className="plan-options">
                <label className="plan-option">
                  <input
                    type="radio"
                    name="plan"
                    value="free"
                    checked={plan === "free"}
                    onChange={(e) => setPlan(e.target.value)}
                  />
                  <div className="plan-card">
                    <div className="plan-name">Free</div>
                    <div className="plan-price">$0/month</div>
                  </div>
                </label>
                <label className="plan-option">
                  <input
                    type="radio"
                    name="plan"
                    value="premium"
                    checked={plan === "premium"}
                    onChange={(e) => setPlan(e.target.value)}
                  />
                  <div className="plan-card">
                    <div className="plan-name">Premium</div>
                    <div className="plan-price">$9/month</div>
                  </div>
                </label>
              </div>
            </div> */}

            <button type="submit" className="register-btn" disabled={loading}>
              {loading ? (
                <>
                  <div className="btn-spinner"></div>
                  Creating Account...
                </>
              ) : (
                "Create Account"
              )}
            </button>
          </form>

          <div className="register-footer">
            Already have an account? <a href="/login">Sign In</a>
          </div>
        </div>
      </div>
    </>
  )
}
